export const USE_SUGGESTED_PRICE = 'use-suggested-price';
export const SUBMIT_BUTTON = 'submit-button';
export const CANCEL_BUTTON = 'cancel-button';
export const NOTES = 'notes';
export const COLLECTION_LOCATION = 'collection-location';
export const COLLECTION_RB = 'collection-rb';
export const DELIVERY_REQUIRED_RB = 'delivery-required-rb';
export const SUGGESTED_PRICE_DETAIL = 'suggested-price-detail';
export const CHARGE = 'charge';
export const OFF_HIRE_TIME = 'off-hire-time';
export const OFF_HIRE_DATE = 'off-hire-date';
export const ON_HIRE_TIME = 'on-hire-time';
export const ON_HIRE_DATE = 'on-hire-date';
export const AVAILABILITY = 'availability';
export const PRODUCT_SELECT = 'product-select';
export const CATEGORY_SELECT = 'category-select';
export const ITEM_SELECT = 'item-select';
export const ITEM_QUANTITY = 'item-quantity';
